import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import BetterSelect from "./BetterSelect";
import BetterAlerts from "./BetterAlerts";
import { importarAlteracaoMassa } from "../crud/contrato.crud";

export default class ModalAlteracaoMassa extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            tipo_alteracao: "",
            errors: [],
            success: [],
            warnings: [],
            showAlerts: false,
        };
    }

    importar = (file) => {
        if (!file) {
            return;
        }

        if (!this.state.tipo_alteracao) {
            this.setState({
                errors: ['Por favor, selecione o tipo de alteração antes de importar o arquivo.'],
                success: [],
                warnings: [],
                showAlerts: true
            });
            return;
        }

        const allowedExtensions = ['.xlsx', '.xls'];
        const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
        
        if (!allowedExtensions.includes(fileExtension)) {
            this.setState({
                errors: ['Por favor, selecione um arquivo Excel válido (.xlsx ou .xls).'],
                success: [],
                warnings: [],
                showAlerts: true
            });
            return;
        }

        this.setState({
            errors: [],
            success: [],
            warnings: [],
            showAlerts: false,
            submitted: true
        });

        const form_data = new FormData();

        form_data.append("xls", file);
        form_data.append('tipo_alteracao', this.state.tipo_alteracao);


        importarAlteracaoMassa(form_data).then((res) => {            
            const responseData = res.data;
            
            if (res.status === 200) {
                const errors = responseData.errors || [];
                const success = responseData.success || [];
                const warnings = responseData.warnings || [];
                
                const formattedWarnings = warnings.map(warning => {
                    if (typeof warning === 'string') {
                        return warning;
                    }
                    if (warning && typeof warning === 'object' && warning.placa && warning.erro) {
                        return `Placa ${warning.placa}: ${warning.erro}`;
                    }
                    return String(warning || 'Aviso desconhecido');
                });

                const successCount = Array.isArray(success) ? success.length : 0;

                const successMessages = successCount > 0
                    ? [`${successCount} alteração(ões) aplicada(s) com sucesso.`]
                    : [];

                this.setState({
                    errors,
                    success: successMessages,
                    warnings: formattedWarnings,
                    showAlerts: true
                });

                if (errors.length === 0 && successCount === 0) {
                    this.setState(prevState => ({
                        success: [],
                        warnings: [...prevState.warnings, responseData.message || 'Nenhuma alteração foi processada.']
                    }));
                } else if (errors.length === 0 && successCount > 0 && this.props.after) {
                    this.props.after();
                }
            } else {
                this.setState({
                    errors: ['Erro inesperado no servidor.'],
                    success: [],
                    warnings: [],
                    showAlerts: true
                });
            }
        }).catch((err) => {            
            let errorMessage = 'Erro ao processar o arquivo.';
            
            if (err.response) {
                const responseData = err.response.data;
                
                if (responseData.errors && Array.isArray(responseData.errors)) {
                    this.setState({
                        errors: responseData.errors,
                        success: [],
                        warnings: [],
                        showAlerts: true
                    });
                } else if (responseData.message) {
                    this.setState({
                        errors: [responseData.message],
                        success: [],
                        warnings: [],
                        showAlerts: true
                    });
                } else {
                    this.setState({
                        errors: [errorMessage],
                        success: [],
                        warnings: [],
                        showAlerts: true
                    });
                }
            } else if (err.request) {
                this.setState({
                    errors: ['Erro de conexão. Verifique sua internet e tente novamente.'],
                    success: [],
                    warnings: [],
                    showAlerts: true
                });
            } else {
                this.setState({
                    errors: [errorMessage],
                    success: [],
                    warnings: [],
                    showAlerts: true
                });
            }
        }).finally(() => {
            this.setState({ submitted: false });
        });
    };

    limparAlertas = () => {
        this.setState({
            errors: [],
            success: [],
            warnings: [],
            showAlerts: false
        });
    };

    render() {
        return (
            <Modal show={this.props.open} onHide={() => this.props.setOpen(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="tt-14 color-gray-100 semibold">{"Alteração em massa"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Alertas */}
                    {this.state.showAlerts && (
                        <div className="mb-4">
                            <BetterAlerts 
                                errors={this.state.errors}
                                success={this.state.success}
                                warnings={this.state.warnings}
                            />
                        </div>
                    )}

                    <div className="row py-4">
                        <div className="col-sm-12">
                            <BetterSelect 
                                label="Tipo de Alteração" 
                                labelWidth={55} 
                                onChange={(e) => {
                                    this.setState({ tipo_alteracao: e.target.value });
                                    this.limparAlertas();
                                }} 
                                value={this.state.tipo_alteracao} 
                                blankOption
                            >
                                <option value="status">Alterar Status</option>
                                <option value="data_vencimento">Alterar Data de Vencimento</option>
                            </BetterSelect>
                        </div>

                        <div className="col-sm-12">
                            <input 
                                required 
                                type="file" 
                                accept={".xls,.xlsx"} 
                                name={"importar-placas"} 
                                className="d-none" 
                                id={`contained-button-file-img-importar-placas`} 
                                onChange={(e) => this.importar(e.target.files[0])}
                                disabled={this.state.submitted}
                            />

                            <label htmlFor={`contained-button-file-img-importar-placas`} style={{ marginBottom: "0px" }}>
                                <span className={`add-imagem btn btn-primary btn-bold ${this.state.submitted ? 'disabled' : ''}`}>
                                    <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fas fa-file-upload"}`}></i>
                                    {this.state.submitted ? "Processando..." : "Importar placas"}
                                </span>
                            </label>
                            
                            {this.state.tipo_alteracao && (
                                <div className="mt-2">
                                    <small className="text-muted">
                                        {this.state.tipo_alteracao === 'status' 
                                            ? 'Arquivo deve conter: Coluna A (Placa) e Coluna B (Status)'
                                            : 'Arquivo deve conter: Coluna A (Placa) e Coluna B (Dia de Vencimento)'
                                        }
                                    </small>
                                </div>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={() => {
                            this.limparAlertas();
                            this.props.setOpen(false);
                        }}
                        disabled={this.state.submitted}
                    >
                        Fechar
                    </Button>
                    {this.state.showAlerts && (
                        <Button 
                            variant="outline-secondary" 
                            onClick={this.limparAlertas}
                            disabled={this.state.submitted}
                        >
                            Limpar Alertas
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        );
    }
}
